import { apiRequestWithConfig } from '@lib/api-fetch';
import { ClientSafeConfig } from '@lib/context/config-context';
import { fetch_timeout_duration } from '@lib/constants/network-constants';
import { getRuntimeConfig } from '@lib/util/runtime-config-util';

export async function geoLocationAsync(latitude: number, longitude: number, config?: ClientSafeConfig): Promise<any> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);

  const response = await apiRequestWithConfig(
    'GET',
    `/geolocation/${latitude}/${longitude}`,
    {},
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
  return response;
}